// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("slider-images", (element, {}, { cleanup }) => {
  const dom = {
    viewportNode: ensureHTMLElement(element.querySelector(".c-slider-images__slider-viewport")),
    nextBtnNode: element.querySelector<HTMLButtonElement>(".c-slider-images__btn-next"),
    prevBtnNode: element.querySelector<HTMLButtonElement>(".c-slider-images__btn-prev"),
  };

  if (!dom.nextBtnNode || !dom.prevBtnNode) {
    return;
  }

  const slider = EmblaCarousel(dom.viewportNode, { align: "start" });

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(slider, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  slider.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    slider.destroy();
  });
});
